/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ApiPlanFinancement } from "../model"
// @ts-ignore
import type { PlanFinancementInput } from "../model"
/**
 * PlanFinancementResourceV2Api - axios parameter creator
 */
export const PlanFinancementResourceV2ApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Add a new entry to financial plan
     * @param {string} noteId
     * @param {AddNewEntryTypeEnum} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addNewEntry: async (
      noteId: string,
      type: AddNewEntryTypeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("addNewEntry", "noteId", noteId)
      // verify required parameter 'type' is not null or undefined
      assertParamExists("addNewEntry", "type", type)
      const localVarPath = `/v2.0/planFinancement/{noteId}/entry/{type}`
        .replace("{noteId}", encodeURIComponent(String(noteId)))
        .replace("{type}", encodeURIComponent(String(type)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete an entry from financial plan
     * @param {string} noteId
     * @param {string} entryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntry: async (
      noteId: string,
      entryId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("deleteEntry", "noteId", noteId)
      // verify required parameter 'entryId' is not null or undefined
      assertParamExists("deleteEntry", "entryId", entryId)
      const localVarPath = `/v2.0/planFinancement/{noteId}/entry/{entryId}`
        .replace("{noteId}", encodeURIComponent(String(noteId)))
        .replace("{entryId}", encodeURIComponent(String(entryId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete financial plan by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePlanFinancement: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("deletePlanFinancement", "noteId", noteId)
      const localVarPath = `/v2.0/planFinancement/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get financial plan by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrievePlanFinancement: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("retrievePlanFinancement", "noteId", noteId)
      const localVarPath = `/v2.0/planFinancement/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update financial plan
     * @param {PlanFinancementInput} planFinancementInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePlanFinancement: async (
      planFinancementInput: PlanFinancementInput,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'planFinancementInput' is not null or undefined
      assertParamExists("updatePlanFinancement", "planFinancementInput", planFinancementInput)
      const localVarPath = `/v2.0/planFinancement`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        planFinancementInput,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PlanFinancementResourceV2Api - functional programming interface
 */
export const PlanFinancementResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanFinancementResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Add a new entry to financial plan
     * @param {string} noteId
     * @param {AddNewEntryTypeEnum} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addNewEntry(
      noteId: string,
      type: AddNewEntryTypeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlanFinancement>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addNewEntry(noteId, type, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlanFinancementResourceV2Api.addNewEntry"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete an entry from financial plan
     * @param {string} noteId
     * @param {string} entryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEntry(
      noteId: string,
      entryId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlanFinancement>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntry(
        noteId,
        entryId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlanFinancementResourceV2Api.deleteEntry"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete financial plan by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePlanFinancement(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanFinancement(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlanFinancementResourceV2Api.deletePlanFinancement"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get financial plan by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retrievePlanFinancement(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlanFinancement>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePlanFinancement(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlanFinancementResourceV2Api.retrievePlanFinancement"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update financial plan
     * @param {PlanFinancementInput} planFinancementInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePlanFinancement(
      planFinancementInput: PlanFinancementInput,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlanFinancement>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanFinancement(
        planFinancementInput,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlanFinancementResourceV2Api.updatePlanFinancement"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PlanFinancementResourceV2Api - factory interface
 */
export const PlanFinancementResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PlanFinancementResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Add a new entry to financial plan
     * @param {PlanFinancementResourceV2ApiAddNewEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addNewEntry(
      requestParameters: PlanFinancementResourceV2ApiAddNewEntryRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiPlanFinancement> {
      return localVarFp
        .addNewEntry(requestParameters.noteId, requestParameters.type, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete an entry from financial plan
     * @param {PlanFinancementResourceV2ApiDeleteEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntry(
      requestParameters: PlanFinancementResourceV2ApiDeleteEntryRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiPlanFinancement> {
      return localVarFp
        .deleteEntry(requestParameters.noteId, requestParameters.entryId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete financial plan by note id
     * @param {PlanFinancementResourceV2ApiDeletePlanFinancementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePlanFinancement(
      requestParameters: PlanFinancementResourceV2ApiDeletePlanFinancementRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deletePlanFinancement(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get financial plan by note id
     * @param {PlanFinancementResourceV2ApiRetrievePlanFinancementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrievePlanFinancement(
      requestParameters: PlanFinancementResourceV2ApiRetrievePlanFinancementRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiPlanFinancement> {
      return localVarFp
        .retrievePlanFinancement(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update financial plan
     * @param {PlanFinancementResourceV2ApiUpdatePlanFinancementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePlanFinancement(
      requestParameters: PlanFinancementResourceV2ApiUpdatePlanFinancementRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiPlanFinancement> {
      return localVarFp
        .updatePlanFinancement(requestParameters.planFinancementInput, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addNewEntry operation in PlanFinancementResourceV2Api.
 */
export interface PlanFinancementResourceV2ApiAddNewEntryRequest {
  readonly noteId: string

  readonly type: AddNewEntryTypeEnum
}

/**
 * Request parameters for deleteEntry operation in PlanFinancementResourceV2Api.
 */
export interface PlanFinancementResourceV2ApiDeleteEntryRequest {
  readonly noteId: string

  readonly entryId: string
}

/**
 * Request parameters for deletePlanFinancement operation in PlanFinancementResourceV2Api.
 */
export interface PlanFinancementResourceV2ApiDeletePlanFinancementRequest {
  readonly noteId: string
}

/**
 * Request parameters for retrievePlanFinancement operation in PlanFinancementResourceV2Api.
 */
export interface PlanFinancementResourceV2ApiRetrievePlanFinancementRequest {
  readonly noteId: string
}

/**
 * Request parameters for updatePlanFinancement operation in PlanFinancementResourceV2Api.
 */
export interface PlanFinancementResourceV2ApiUpdatePlanFinancementRequest {
  readonly planFinancementInput: PlanFinancementInput
}

/**
 * PlanFinancementResourceV2Api - object-oriented interface
 */
export class PlanFinancementResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Add a new entry to financial plan
   * @param {PlanFinancementResourceV2ApiAddNewEntryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addNewEntry(
    requestParameters: PlanFinancementResourceV2ApiAddNewEntryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanFinancementResourceV2ApiFp(this.configuration)
      .addNewEntry(requestParameters.noteId, requestParameters.type, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete an entry from financial plan
   * @param {PlanFinancementResourceV2ApiDeleteEntryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteEntry(
    requestParameters: PlanFinancementResourceV2ApiDeleteEntryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanFinancementResourceV2ApiFp(this.configuration)
      .deleteEntry(requestParameters.noteId, requestParameters.entryId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete financial plan by note id
   * @param {PlanFinancementResourceV2ApiDeletePlanFinancementRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deletePlanFinancement(
    requestParameters: PlanFinancementResourceV2ApiDeletePlanFinancementRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanFinancementResourceV2ApiFp(this.configuration)
      .deletePlanFinancement(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get financial plan by note id
   * @param {PlanFinancementResourceV2ApiRetrievePlanFinancementRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public retrievePlanFinancement(
    requestParameters: PlanFinancementResourceV2ApiRetrievePlanFinancementRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanFinancementResourceV2ApiFp(this.configuration)
      .retrievePlanFinancement(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update financial plan
   * @param {PlanFinancementResourceV2ApiUpdatePlanFinancementRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updatePlanFinancement(
    requestParameters: PlanFinancementResourceV2ApiUpdatePlanFinancementRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanFinancementResourceV2ApiFp(this.configuration)
      .updatePlanFinancement(requestParameters.planFinancementInput, options)
      .then(request => request(this.axios, this.basePath))
  }
}

export const AddNewEntryTypeEnum = {
  BESOINS: "BESOINS",
  APPORTS: "APPORTS",
  PRIMES: "PRIMES",
  SUBVENTIONS_INVESTISSEMENTS: "SUBVENTIONS_INVESTISSEMENTS",
  PRETS_AT: "PRETS_AT",
  PRETS_HORS_AT_GARANTIS: "PRETS_HORS_AT_GARANTIS",
  PRETS_HORS_AT_NON_GARANTIS: "PRETS_HORS_AT_NON_GARANTIS",
  CREDIT_RELAIS_TVA: "CREDIT_RELAIS_TVA"
} as const
export type AddNewEntryTypeEnum = (typeof AddNewEntryTypeEnum)[keyof typeof AddNewEntryTypeEnum]
